import $ from 'jquery';

const stash = window.Stash['widgets/jix_file_field'];

const defaultLang = 'da';
const trans = {
    'en': '{n} files selected',
    'da': '{n} filer valgt',
    'sv': '{n} filer valda',
    'nb': '{n} filer valgt'
};

function getLang($elem) {
    let lang = $elem.closest('[lang]').attr('lang') || 'en';
    lang = lang.replace(/-.*$/, '');
    return lang;
}

function init(id) {
    const container = document.getElementById(id);
    const label = container.querySelector('label');
    const field = container.querySelector('input');

    const origLabel = label.textContent;

    const update = () => {
        const numFiles = field.files ? field.files.length : 1;
        const filename = field.value.replace(/\\/g, '/').replace(/.*\//, '');

        if (numFiles === 1) {
            label.textContent = filename;
        } else if (numFiles === 0) {
            label.textContent = origLabel;
        } else {
            const lang = getLang($(container));
            let newLabel = lang in trans ? trans[lang] : trans[defaultLang];
            newLabel = newLabel.replace('{n}', numFiles);
            label.textContent = newLabel;
        }
    };

    field.addEventListener('change', update);
    update();
}

$(() => {
    stash.forEach(({ id }) => init(id));
});
